// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LanguageDropdown.css */

/* Conteneur principal pour le dropdown */
.language-dropdown {
  position: relative;
  display: inline-block;
}

/* Conteneur pour le drapeau sélectionné */
.selected-flag-container {
  width: 40px;
  /* Taille du cercle */
  height: 40px;
  border-radius: 50%;
  /* Cercle */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border 0.3s;
  border: 2px solid transparent;
  /* Bord initial */
  cursor: pointer;
}

/* Drapeau sélectionné */
.selected-flag {
  font-size: 2rem;
  /* Ajuste la taille de l'icône du drapeau pour remplir la bulle */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover !important;
}

/* Effet de survol sur le conteneur du drapeau */
.selected-flag-container:hover {
  border: 2px solid #007bff;
  /* Couleur de survol du bord */
}

/* Liste déroulante des langues */
.dropdown-list {
  position: absolute;
  top: 55px;
  /* Positionner sous le drapeau */
  background-color: #F7F4EE;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 1000;
  /* S'assurer que la liste est au-dessus des autres éléments */
}

/* Élément de la liste déroulante */
.dropdown-flag-item {
  color: #4D4E51;
  font-weight: 500;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dropdown-item {
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dropdown-flag-item:hover {
  opacity: 0.4;
  background-color: #f8fafc;
}

/* Drapeau dans les éléments de la liste */
.dropdown-flag {
  font-size: 1rem;
  /* Taille des drapeaux dans la liste */
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/LanguageDropdown.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,yCAAyC;AACzC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iEAAiE;EACjE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,6DAA6D;AAC/D;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB","sourcesContent":["/* LanguageDropdown.css */\n\n/* Conteneur principal pour le dropdown */\n.language-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n/* Conteneur pour le drapeau sélectionné */\n.selected-flag-container {\n  width: 40px;\n  /* Taille du cercle */\n  height: 40px;\n  border-radius: 50%;\n  /* Cercle */\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: border 0.3s;\n  border: 2px solid transparent;\n  /* Bord initial */\n  cursor: pointer;\n}\n\n/* Drapeau sélectionné */\n.selected-flag {\n  font-size: 2rem;\n  /* Ajuste la taille de l'icône du drapeau pour remplir la bulle */\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-size: cover !important;\n}\n\n/* Effet de survol sur le conteneur du drapeau */\n.selected-flag-container:hover {\n  border: 2px solid #007bff;\n  /* Couleur de survol du bord */\n}\n\n/* Liste déroulante des langues */\n.dropdown-list {\n  position: absolute;\n  top: 55px;\n  /* Positionner sous le drapeau */\n  background-color: #F7F4EE;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.2);\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  z-index: 1000;\n  /* S'assurer que la liste est au-dessus des autres éléments */\n}\n\n/* Élément de la liste déroulante */\n.dropdown-flag-item {\n  color: #4D4E51;\n  font-weight: 500;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dropdown-item {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dropdown-flag-item:hover {\n  opacity: 0.4;\n  background-color: #f8fafc;\n}\n\n/* Drapeau dans les éléments de la liste */\n.dropdown-flag {\n  font-size: 1rem;\n  /* Taille des drapeaux dans la liste */\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
